import React, { useState } from 'react';
import { getRelatedSearchQueries } from '../services/geminiService';
import { SparklesIcon } from 'shared-icons';

const SearchKeywords: React.FC = () => {
    const [aiKeywords, setAiKeywords] = useState<string[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const initialKeywords = [
        "internet speed test",
        "what is a good download speed",
        "how to improve wifi signal",
        "ping test online",
        "best internet provider in my area",
        "4k streaming speed requirements",
        "why is my internet so slow",
        "online gaming latency test",
    ];

    const handleGetAIKeywords = async () => {
        setIsLoading(true);
        setError(null);
        setAiKeywords([]);
        try {
            const queries = await getRelatedSearchQueries();
            setAiKeywords(queries);
        } catch (e) {
            setError(e instanceof Error ? e.message : 'Failed to fetch AI keywords.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="w-full max-w-4xl p-6 bg-white/20 dark:bg-slate-800/20 backdrop-blur-sm rounded-lg border border-white/30 dark:border-slate-700/50">
            <h2 className="text-xl font-bold text-slate-800 dark:text-slate-200 mb-4">Popular Internet Speed Searches</h2>
            <div className="flex flex-wrap gap-2">
                {initialKeywords.map(keyword => (
                    <span key={keyword} className="px-3 py-1 bg-white/30 dark:bg-slate-700/60 backdrop-blur-sm border border-white/40 dark:border-slate-600/60 rounded-full text-sm text-slate-800 dark:text-slate-200">
                        {keyword}
                    </span>
                ))}
            </div>
            
            <div className="mt-6 text-center">
                 <button 
                    onClick={handleGetAIKeywords} 
                    disabled={isLoading}
                    className="inline-flex items-center justify-center gap-2 px-5 py-2 bg-gradient-to-r from-cyan-500 to-purple-600 text-white font-semibold rounded-full shadow-lg shadow-purple-500/20 hover:shadow-purple-500/40 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-opacity-75 transition-all disabled:opacity-50 disabled:cursor-wait"
                >
                    <SparklesIcon width={20} height={20} />
                    {isLoading ? 'Generating...' : 'Discover AI-Powered Search Ideas'}
                </button>
            </div>
            
            {error && <p className="mt-4 text-center text-red-500 dark:text-red-400">{error}</p>}

            {aiKeywords.length > 0 && (
                <div className="mt-6 pt-6 border-t border-gray-200 dark:border-slate-700">
                     <h3 className="text-lg font-bold text-slate-800 dark:text-slate-200 mb-3 text-center">AI Generated Ideas</h3>
                     <div className="flex flex-wrap gap-2 justify-center">
                        {aiKeywords.map(keyword => (
                            <span key={keyword} className="px-3 py-1 bg-cyan-500/20 dark:bg-cyan-900/30 backdrop-blur-sm border border-cyan-500/30 dark:border-cyan-700/50 rounded-full text-sm text-cyan-800 dark:text-cyan-200">
                                {keyword}
                            </span>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default SearchKeywords;